<template>
  <div class="modal new-asset-modal" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Upload to {{ data.dataset_name }}</h5>
          <button
            type="button"
            class="modal__new-asset-close close"
            data-dismiss="modal"
            aria-label="Close"
            @click="closeModal"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <!-- <label class="mb-0" for="dataset_id">Dataset Id</label>
          <input id="dataset_id" class="modal__elements form-control" type="text" v-model="dataset_id" /> -->
          <label class="mb-0" for="files">Files</label>
          <input
            id="files"
            class=" modal__elements modal-file-input form-control mb-4"
            type="file"
            ref="filesRef"
            multiple
            @change="filesChanged"
          />
          <label class="mb-0" for="path">Destination Path</label>
          <input id="path" class="modal__elements form-control" type="text" v-model="path" />
          <!-- <div class="files-selected">
            <p v-for="file in files" class="filename">{{ file.name }}</p>
          </div> -->
          <!-- <div class="files" v-for="(file, idx) in files" :key="idx">
            <label class="mb-0" :for="'file' + idx">File</label>
            <div class="file-input-button">
              <input
                :id="'file' + idx"
                class=" modal__elements modal-file-input form-control"
                type="file"
                ref="file"
                multiple
              />
              <button
                v-if="files.length > 1"
                class="modal-button-remove-file btn-reset bold-me text-primary"
                @click="removeFile(idx)"
              >
                X
              </button>
            </div>
          </div> -->
          <!-- <div class="modal-add-file mt-2 mb-4">
            <button class="btn btn-sm btn-secondary ml-auto d-block" @click="addFile">+ Add File</button>
          </div> -->
          <div class="modal-buttons mt-2 mb-2">
            <button
              class="modal__elements-cancel btn btn-primary"
              data-dismiss="modal"
              @click="closeModal"
            >
              Cancel
            </button>
            <button
              class="modal__elements-saveedit btn btn-primary float-right"
              data-dismiss="modal"
              @click="saveAsset"
            >
              Upload
            </button>
          </div>
        </div>
        <div class="modal-footer">.</div>
      </div>
    </div>
  </div>
</template>
<script>
import * as api from '@/lib/api'

export default {
  name: 'NewAssetModal',
  props: {
    data: { type: Object, default: {} },
  },
  data() {
    return {
      path: '',
      files: [],
      response: '',
    }
  },
  mounted() {
    console.log(this.data)
  },
  methods: {
    async saveAsset() {
      console.log('saving Asset')
      this.response = await api.uploadAsset(
        this.files,
        this.path,
        this.data.collection_id,
        (event) => {
          this.progress = Math.round((100 * event.loaded) / event.total)
        }
      )
      this.$emit('assetSaved', this.response)
      console.log('api save asset response', this.response)
      this.clearModalData()
    },
    // addFile() {
    //   console.log('add File')
    //   this.files.push('')
    // },
    // removeFile(idx) {
    //   console.log('remove File', idx)
    //   this.files.splice(idx, 1)
    // },
    filesChanged(e) {
      console.log(e.target.files, this.path)
      this.files = Array.from(e.target.files)
    },
    closeModal() {
      this.clearModalData()
      this.$emit('closeFormModal')
    },
    clearModalData() {
      this.path = ''
      this.files = []
      this.$refs.filesRef.value = null
    },
  },
  watch: {
    data: {
      deep: true,
      handler: function() {
        console.log(this.data)
        if (!this.data.dataset_id) {
          console.log('cleared model data too')
          this.clearModalData()
        }
      },
    },
  },
}
</script>
<style lang="scss" scoped>
@import '~@/styles/globals';

.modal .modal-dialog .modal-content {
  border: none;
  border-radius: $border-radius;
  .modal-header {
    border-radius: $border-radius $border-radius 0 0;
    background: $neutral-space;
  }

  .modal-body {
    border: none;
  }
  .modal-footer {
    border-radius: 0 0 $border-radius $border-radius;
    border: none;
    background-color: $primary;
    align-items: flex-start;
    button {
      color: $white-ghost;
      &:hover {
        color: $main;
      }
    }
  }
}

.asset__modal-actions {
  display: flex;
  .icon {
    padding: 0;
  }
}

.asset__modal-group {
  h4 {
    font-size: 1.3rem !important;
    font-weight: bold !important;
    color: $black-85 !important;
  }
  p {
    margin-bottom: 4px;
  }
}

.asset__new-asset-close {
  position: absolute;
  right: 1rem;
  top: 1rem;
  // background-color: green;
  border-radius: 0.3rem;
  opacity: 1;
  span {
    opacity: 0.8;
    color: $deep-space;
  }
  &:hover {
    opacity: 1 !important;
    span {
      color: $deep-space;
      opacity: 1;
    }
  }
}

label {
  font-size: 14px;
  margin-top: 10px;
}

.modal-file-input::file-selector-button {
  display: inline-block;
  color: #fff;
  background-color: #6c757d;
  text-align: center;
  vertical-align: middle;
  border: 1px solid #6c757d;
  padding: 1px 8px;
  border-radius: $border-radius;
}

// UNNEEDED, CONSIDER DELETE
// .file-input-button {
//   display: flex;
//   .modal-file-input::file-selector-button {
//     display: inline-block;
//     color: #fff;
//     background-color: #6c757d;
//     text-align: center;
//     vertical-align: middle;
//     border: 1px solid #6c757d;
//     padding: 1px 8px;
//     border-radius: $border-radius;
//   }
//   .modal-button-remove-file {
//     margin-left: 6px;
//     border: 1px solid #ced4da;
//     border-radius: $border-radius;
//     width: 36px;
//   }
// }
// .modal-add-file {
//   button {
//     border-radius: $border-radius;
//   }
// }
</style>
